<template>
  <a-dropdown v-if="hasResults" :trigger="['click']">
    <a-button type="default" size="large" class="export-button" v-bind="$attrs">
      <DownloadOutlined />
      Export
      <DownOutOutlined />
    </a-button>
    <template #overlay>
      <a-menu @click="handleMenuClick">
        <a-menu-item key="csv">
          <FileTextOutlined />
          Export as CSV
        </a-menu-item>
        <a-menu-item key="json">
          <FileOutlined />
          Export as JSON
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import {
  DownloadOutlined,
  DownOutlined as DownOutOutlined,
  FileTextOutlined,
  FileOutlined,
} from '@ant-design/icons-vue';
import type { Domain } from '../types';

interface Props {
  results: Domain[];
}

interface Emits {
  (e: 'export', format: 'csv' | 'json'): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const hasResults = computed(() => props.results && props.results.length > 0);

const handleMenuClick = ({ key }: { key: string }) => {
  if (key === 'csv' || key === 'json') {
    emit('export', key);
  }
};
</script>

<style scoped lang="scss">
.export-button {
  font-weight: 600;

  :deep(.anticon) {
    margin-right: 4px;
  }
}
</style>
